import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table sessions report view.
 * @extends JetView
 */
export default class tableSessionsReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user parameter

        // Extend the summTreeColumn filter to calculate and display summary values
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result variable
                    var resultFormat = 0; // Initialize formatted result variable
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format the result based on the column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend from summColumn filter
        );

        // Return the layout configuration for the view
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the DataTable
                            footer: true, // Enable footer
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                // Define columns for the DataTable
                                {
                                    id: 'SessionId',
                                    header: _('ID Sesión'), // Localized header
                                    width: 100,
                                    sort: 'int', // Enable integer sorting
                                    footer: 'Total:', // Footer label
                                },
                                {
                                    id: 'PlayerId',
                                    header: _('ID Usuario'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'StartTime',
                                    header: _('Hora Inicio'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'EndTime',
                                    header: _('Hora Fin'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'PromCreditsReceived',
                                    header: _('Créditos Promocionales Recibidos'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' }, // Footer content type
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'PromCreditsWagered',
                                    header: _('Créditos Promocionales Apostados'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'RemainingFunds',
                                    header: _('Fondos Restantes de Juegos Incompletos'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'TypeClosed',
                                    header: _('Motivo Cierre'), // Localized header
                                    options: [
                                        // Options for the dropdown
                                        { id: '', value: _('None') },
                                        { id: 'M', value: _('Manual') },
                                        { id: 'A', value: _('Automático') },
                                        { id: 'S', value: _('Sistema') },
                                    ],
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'SaldoEnd',
                                    header: _('Saldo al Final'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'Deposit',
                                    header: _('Valor de depósitos'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'SportsSum',
                                    header: _('Apuestas deportivas'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'SportsAwards',
                                    header: _('Premios deportivos'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'SportsCancellation',
                                    header: _('Cancelaciones deportivas'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'BetCasino',
                                    header: _('Apuestas de casino'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'CasinoAward',
                                    header: _('Premios de casino'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'CasinoCancellation',
                                    header: _('Cancelaciones de casino'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'WithdrawalsMade',
                                    header: _('Retiros realizados'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'CanceledWithdrawals',
                                    header: _('Retiros cancelados'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'BonusRedeemed',
                                    header: _('Bonos redimidos'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    footer: { content: 'summColumn' },
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                            ],
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch data configuration
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no data
                                    webix.extend(this, webix.OverlayBox); // Extend with OverlayBox
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Localized no data message
                                            '</div>',
                                    );
                                }
                            },
                            pager: 'pagerA', // ID for the pager
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url =
            devConfig.geturlApi() + // Base URL for API
            'null/Report/getSessions?PlayerId=' + // Endpoint for getting sessions
            cur_user +
            '&';
        var filter = ''; // Initialize filter variable

        // Event handler for filtering session reports
        this.on(this.app, 'sessionReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Add PlayerId to query
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Event handler for sorting the data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for data requests
        grid.attachEvent('onDataRequest', function (start, count) {
            custom_load(this.data.url, start, count); // Custom load function
            return true;
        });

        /**
         * Custom load function to fetch data from the server.
         * @param {string} url - The URL to fetch data from.
         * @param {number} start - The starting index for data.
         * @param {number} count - The number of records to fetch.
         */
        function custom_load(url, start, count) {
            grid.load(
                url + '?start=' + start + '&count=' + count + '&PlayerId' + cur_user, // Load data with pagination
            );
        }

        // Event handler for before loading data
        grid.attachEvent('onBeforeLoad', function () {
            webix.message('Loading...'); // Show loading message
            return true;
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
